import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useBuilderActionContextV2 } from '@/context/__project__/BuilderActionContextV2'
import { useCompBackgroundColor, useCompContext } from '@/context/__project__/CompContext'
import { useAppBrandKitContext } from '@/context/AppBrandKitContext'
import { useBuilderColorSchemeV2 } from '@/hooks/__project__/useBuilderColorSchemeV2'

import { CompCircularProgressWrapperCore } from '../core/circular-progress/wrapper'
import { CompCircularProgress } from './CompCircularProgress'

/**
 * CompCircularProgressWrapper
 */
const CompCircularProgressWrapper = () => {
  const compContext = useCompContext()
  const actionContext = useBuilderActionContextV2()
  const { activeLayer } = useActiveLayerContext()
  const { currentParentBg } = useCompBackgroundColor()

  const [themeState] = useBuilderColorSchemeV2()
  const { themes, currentTheme } = useAppBrandKitContext()

  return (
    <CompCircularProgressWrapperCore
      infos={{ ...compContext, activeLayer, currentParentBg }}
      action={actionContext}
      brandkit={{ mode: themeState.current, themes, currentTheme }}
    >
      {(props) => <CompCircularProgress {...props} />}
    </CompCircularProgressWrapperCore>
  )
}


export default CompCircularProgressWrapper